import initialState from '../store/initialState'
import paymentsTypes from '../constants/paymentsTypes'

export default function paymentsReducer(state = initialState.payments, action) {
  switch (action.type) {

    case paymentsTypes.set_errors: {
      return {
        ...state,
        errors: action.payload
      }
    }

    // GET
    case paymentsTypes.receipt.request:
    case paymentsTypes.get.request: {
      return {
        ...state,
        fetching_single: true,
        fetched_single: false,
        errors: []
      }
    }

    case paymentsTypes.get.success: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: true,
        payment: action.payload,
      }
    }

    case paymentsTypes.receipt.failure:
    case paymentsTypes.get.failure: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: false,
        errors: action.payload
      }
    }

    case paymentsTypes.receipt.success: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: true,
        errors: []
      }
    }

    // INDEX
    case paymentsTypes.index.request: {
      return {
        ...state,
        fetching: true,
        fetched: false,
        errors: []
      }
    }

    case paymentsTypes.index.success: {
      if (action.payload.serial && state.serial && action.payload.serial < state.serial) {
        // ignore
        // console.log('index request ignored; consequent request already served')
        return {
          ...state
        }
      }
      return {
        ...state,
        fetching: false,
        fetched: true,
        items: action.payload.payments,
        pagination: action.payload.pagination,
        totals: action.payload.totals,
        serial: action.payload.serial || 0,
      }
    }

    case paymentsTypes.index.failure: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        errors: action.payload
      }
    }

    default: {
      return {...state};
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/reducers/paymentsReducer.js